<template>
<v-container>
  <div class="resumen_tournament">
    <v-row>
      <v-col>

    <div v-if="id" class="pt-3"> Editando Jugador </div>
        <div v-else class="pt-3"> Crear Jugador </div>
      </v-col>
    </v-row>
    <v-row>
  </v-row>
  </div>
<div>

<br>
  <v-row>
    <v-col cols="12" md="4">
      <v-text-field
      label="Rut"
      v-model="player.identificator"
      :rules="rutRules"
      v-debounce:1s="performSearchRut"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="4">
      <v-text-field
      label="Nombre"
      v-model="player.first_name"
      :rules="nameRules"
      v-debounce:1s="performSearchFirstName"
      required
    ></v-text-field>
    </v-col>
      <v-col cols="12" md="4">
      <v-text-field
      label="Segundo Nombre"
      v-model="player.second_name"
      :rules="nameRulesNR"
    ></v-text-field>
    </v-col>
      <v-col cols="12" md="4">
      <v-text-field
      label="Apellido Paterno"
      v-model="player.last_name"
      :rules="nameRules"
      v-debounce:1s="performSearchLastName"
      required
    ></v-text-field>
    </v-col>
      <v-col cols="12" md="4">
      <v-text-field
      label="Apellido Materno"
      v-model="player.last_name_second"
      :rules="nameRulesNR"
    ></v-text-field>
    </v-col>
    <v-col cols="12" md="4">
      <v-text-field label="Fecha Nacimiento dd/mm/yyyy" v-model="player.birthday" :rules="dateRules"></v-text-field>
    </v-col>
    <v-col cols="12" md="4">
      <v-text-field
      label="Email"
      v-model="player.email"
      :rules="emailRules"
    ></v-text-field>
    </v-col>
    <v-col cols="12" md="4">
        <v-select
          v-model="player.gender"
          :items="['Masculino','Femenino']"
          label="Genero"
        ></v-select>
    </v-col>
    <v-col cols="12" md="4">
        <v-select
          v-model="player.federacion_str"
          :items="['CHI','INT']"
          label="Federacion"
        ></v-select>
    </v-col>
    <v-col v-if="!player.fide_identificator" cols="12" md="4">
      <v-text-field
      label="Fide ID"
      v-model="player.fide_identificator_id"
      :rules="numberRules"
    ></v-text-field>
    </v-col>
    <v-col cols="12" md="4">
        <v-autocomplete v-if="tiene"
          v-model="player.club_id"
          :items="club"
          label="Selecciona Club"
          :disabled="true"
        ></v-autocomplete>
      <v-autocomplete v-else
          v-model="player.club_id"
          :items="clubAdmin"
          label="Selecciona Club"
        ></v-autocomplete>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox
      label="Canon"
      v-model="player.canon"
    ></v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox
      label="Canon Confirmado"
      v-model="player.canon_confirm"
    ></v-checkbox>
    </v-col>
    <v-col cols="12" md="4">
      <template v-if="tiene">
        <v-autocomplete v-if="tiene_change"
          v-model="player.requested_change_club_id"
          :items="club"
          label="Solicitar cambio"
          :disabled="tiene_change"
        ></v-autocomplete>
        <v-autocomplete v-else
          v-model="player.requested_change_club_id"
          :items="clubAdmin"
          label="Solicitar cambio"
          :disabled="tiene_change"
        ></v-autocomplete>
      </template>

    </v-col>
     <v-col cols="12" md="4">
      <v-autocomplete
          v-model="player.arbitrers_id"
          :items="categories_arbitrers"
          label="Arbitro"
          multiple
        ></v-autocomplete>
    </v-col>
    <v-col cols="12" md="4">
      <v-autocomplete
          v-model="player.trainers_id"
          :items="categories_trainers"
          label="Entrenador"
          multiple
        ></v-autocomplete>
    </v-col>
    <v-col cols="12" md="4">
      <v-autocomplete
          v-model="player.organizaters_id"
          :items="categories_organizaters"
          label="Organizador"
          multiple
        ></v-autocomplete>
    </v-col>
    <v-col cols="12" md="4">
      <v-autocomplete
          v-model="player.admins_id"
          :items="categories_admins"
          label="Admin"
          multiple
        ></v-autocomplete>
    </v-col>
    <v-col cols="12" md="4">
      <v-autocomplete
          v-model="player.admin_id"
          :items="club"
          label="Administra Club"
          multiple
        ></v-autocomplete>
    </v-col>
    <v-col cols="12" md="4">
      <v-checkbox
      label="Tiene acceso"
      v-model="player.can_access"
    ></v-checkbox>
    </v-col>
    <v-col cols="12">
      <v-btn @click="guardar" color="primary">Guardar</v-btn>
    </v-col>
  </v-row>
  <v-row v-if="registro">
    <v-col>
      <h1 class="text-center">{{registro}}</h1>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          Fed. Id
        </th>
        <th class="text-center">
          Fecha Nacimiento
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in players"
        :key="item.id"
      >
        <td class="text-left" style="width: 800px"><a :href="'/player/'+item.id" style="color:blue">{{ item.full_name }}</a></td>
        <td class="text-center">{{ item.federation_id }}</td>
        <td class="text-center">{{ item.birthday_formated }}</td>
      </tr>
    </tbody>
  </v-table>
    </v-col>
  </v-row>
  </div>
</v-container>

</template>
<script>


import gql from "graphql-tag";
import axios from "axios";
import {vue3Debounce} from "vue-debounce";

export default {

  directives: {
    debounce: vue3Debounce({ lock: true })
  },
  apollo: {
    player: {query: gql` query($id:String!){
       player:person(id:$id){
        id
        identificator
        birthday:birthdayFormated
        email
        gender
        federacion_str:federacionStr
        first_name:firstName
        second_name:secondName
        last_name:lastName
        last_name_second:lastNameSecond
        canon
        canon_confirm:canonConfirm
        fide_identificator:fideIdentificator
        national
        regional
        monitor
        admin_id:adminId
        arbitrers_id:arbitrersId
        trainers_id:trainersId
        organizaters_id:organizatersId
        admins_id:adminsId
        can_access:canAccess
        club_basic:clubBasic{
          id
        }
        requested_change_club:requestedChangeClub{
          id
        }
      }
    }`,
      variables() {return {"id" :this.id}}
    },
    players: {query: gql`  query($first_name:String!, $last_name:String!, $identificator:String!,){
       players(firstName:$first_name, lastName:$last_name, identificator:$identificator){
        id
        full_name:fullName
        birthday_formated:birthdayFormated
        federation_id:federationId
      }
    }`,
      variables() {return {"first_name" :this.first_name_net, "last_name" :this.last_name_net, "identificator":this.identificator_net}}

    },
     club: {query: gql`{
       club {
        value:id
        title:name
      }}`,

    },
    clubAdmin: {query: gql`{
       clubAdmin {
        value:id
        title:name
      }}`,

    },
    categories_arbitrers: {query: gql`{
       categories_arbitrers:categoriesArbitrers {
        value:id
        title:name
      }}`,

    },
    categories_trainers: {query: gql`{
       categories_trainers:categoriesTrainers {
        value:id
        title:name
      }}`,

    },
    categories_organizaters: {query: gql`{
       categories_organizaters:categoriesOrganizaters {
        value:id
        title:name
      }}`,

    },
    categories_admins: {query: gql`{
       categories_admins:categoriesAdmins {
        value:id
        title:name
      }}`,

    },

  },
  props:['id'],
    name:"EditPlayer",
  data() {

    return {
      club:[],
      clubAdmin:[],
      categories_arbitrers:[],
      categories_trainers:[],
      categories_organizaters:[],
      categories_admins:[],
      tournament: null,
      players: null,
      registro: null,
      first_name_net:'',
      last_name_net:'',
      identificator_net:'',
      player:{
        gender:'Masculino',
        federacion_str: 'CHI',
        id:'',
        identificator:'',
        fide_identificator:'',
        fide_identificator_id:'',
        birthday:'',
        email:'',
        first_name:'',
        second_name:'',
        last_name:'',
        last_name_second:'',
        club_id:'',
        canon:false,
        canon_confirm: false,
        requested_change_club_id:'',
        national: false,
        regional: false,
        monitor: false,
        admin_id: [],
        arbitrers_id: [],
        trainers_id: [],
        organizaters_id: [],
        admins_id: [],
        can_access: false,
      },
      tiene:false,
      tiene_change:false,
      rutRules: [
      v =>  v === '' || this.isValidRUT(v) || 'El RUT es inválido',
    ],
      emailRules: [
      v => v === '' || /.+@.+\..+/.test(v) || 'E-mail debe ser válido',
    ],
      dateRules: [
      v => !!v || 'La fecha es requerida',
      v => /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/.test(v) || 'La fecha debe estar en formato dd/mm/yyyy',
    ],
      nameRules: [
      v => !!v || 'El campo es requerido',
  v => (/^[A-Za-zñÑáéíóúÁÉÍÓÚüÜ\s'-]+$/).test(v) || 'El campo es inválido',
    ],
      nameRulesNR: [
  v => (/^[A-Za-zñÑáéíóúÁÉÍÓÚüÜ\s'-]+$/).test(v) || 'El campo es inválido',
    ],
      numberRules: [
      v => (/^[0-9\s'-]+$/).test(v) || 'El campo es inválido debe ser numerico',
    ],
    }
  },
  methods: {
    guardar(){
      const url = '/create_model_player/'; // URL de tu endpoint POST
      this.$recaptcha('submit_form')
      .then((token) => {
        this.player.token = token
        axios.post(url, this.player).then((res) => {
          this.registro = res.data.registro

      })
      .catch(error => {
        console.log(error)
        alert(error.response.data.message)

      })
      })
      .catch((error) => {
        console.log("erorrr", error)
        // Manejar cualquier error que ocurra durante la ejecución de la promesa
      });

    },
    performSearchRut(newVal,type ) {
      console.log('debounced', newVal, type)
      this.identificator_net = newVal;
    },
    performSearchFirstName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.first_name_net = newVal;
    },
    performSearchLastName(newVal,type ) {
      console.log('debounced', newVal, type)
      this.last_name_net = newVal;
    },
    onChange() {
      console.log("this.content",this.content)
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    isValidRUT(input) {
      let rut = input.replace(/\./g,'');
      rut = rut.replace('-','');
      let body = rut.slice(0,-1);
      let dv = rut.slice(-1).toUpperCase();
      let total = 0;
      let factor = 2;

      for(let i = body.length - 1; i >= 0; i--) {
        total += body.charAt(i) * factor;
        factor = (factor === 7) ? 2 : factor + 1;
      }

      let remainder = total % 11;
      let key = 11 - remainder;

      if (key === 11) key = 0;
      if (key === 10) key = "K";

      return key.toString() === dv;
    },
  },
  watch:{
    '$apollo.loading'(val){
      if(!val && this.id){
        this.player = JSON.parse(JSON.stringify(this.player))
        this.player.fide_identificator_id = this.player.fide_identificator
        if(this.player.club_basic){
          this.player.club_id = this.player.club_basic.id
          this.tiene = true
        } else {
          this.player.club_id = ""
        }
        if(this.player.gender == "F"){
          this.player.gender = "Femenino"
        }
        if(this.player.requested_change_club){
          this.player.requested_change_club_id = this.player.requested_change_club.id
          this.tiene_change = true
        } else {
          this.player.requested_change_club_id = ""
        }
        if(this.player.canon == 1){
          this.player.canon = true
        } else {
          this.player.canon = false
        }
        if(this.player.canon_confirm == 1){
          this.player.canon_confirm = true
        } else {
          this.player.canon_confirm = false
        }
      }
    },
  }
}
</script>
<style>
.resumen_tournament{
  font-family: Montserrat;
font-size: 30px;
font-weight: 600;
line-height: 37px;
letter-spacing: 0em;
text-align: left;
color: #F4F4F4;
  background-color:#2A4558;
  text-align: center;

}
@media (max-width: 600px) {
  .resumen_tournament{
    font-size: 24px;
  }
}
</style>
